var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 44,
    height: 45,
    rx: 22,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 17.8609C31.5497 18.0741 31.5497 18.2874 31.5497 18.5008C31.5497 25.0024 26.5997 32.4977 17.5528 32.4977C14.7661 32.4977 12.1762 31.6905 10.0012 30.2894C10.3972 30.335 10.7779 30.3503 11.189 30.3503C13.4887 30.3503 15.6051 29.5736 17.2968 28.2489C15.1345 28.2032 13.3223 26.7868 12.6979 24.8378C13.0025 24.8834 13.3068 24.9139 13.627 24.9139C14.0686 24.9139 14.5101 24.853 14.9212 24.7464C12.6675 24.2895 10.9772 22.3099 10.9772 19.9605V19.8996C11.632 20.2651 12.3933 20.4935 13.2004 20.524C11.8758 19.6408 11.0076 18.1329 11.0076 16.4276C11.0076 15.514 11.2512 14.6763 11.6775 13.9455C14.0986 16.9301 17.7384 18.8815 21.8212 19.0924C21.7451 18.7269 21.6994 18.3462 21.6994 17.9655C21.6994 15.2547 23.8922 13.0483 26.6166 13.0483C28.0327 13.0483 29.3119 13.6422 30.2105 14.6018C31.3224 14.3886 32.3883 13.9774 33.3324 13.414C32.9668 14.5563 32.19 15.5154 31.17 16.1247C32.16 16.0182 33.1191 15.744 34.0027 15.3635C33.3328 16.338 32.4952 17.2062 31.5356 17.9065L31.5344 17.8609Z",
    fill: "#212833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactTwitter);
export default __webpack_public_path__ + "static/media/contact-twitter.729364a7a0da706ce44f20dcf9a27958.svg";
export { ForwardRef as ReactComponent };